__turbopack_context__.v({
  "extraContainer": "tca1pW_extraContainer",
  "extraContent": "tca1pW_extraContent",
  "extraIcon": "tca1pW_extraIcon",
  "extraLines": "tca1pW_extraLines",
  "extraText": "tca1pW_extraText",
  "extraTitle": "tca1pW_extraTitle",
});
